import { __rest } from "tslib";
import pino from "pino/browser.js";
import { DefaultLogLevels } from "../types.js";
function toMessage(record) {
    if (typeof record.message === "string")
        return record.message;
    if (typeof record.msg === "string")
        return record.msg;
    return "";
}
function writeLogWithLevel(method, level) {
    return (raw) => {
        const _a = raw, { message, msg } = _a, rest = __rest(_a, ["message", "msg"]);
        const text = toMessage({ message, msg });
        const formatted = `[${level}]${text.length > 0 ? ` ${text}` : ""}`;
        Object.keys(rest).length === 0 ? method(formatted) : method(formatted, rest);
    };
}
const con = globalThis.console;
const browserMethodByLevel = {
    trace: con.debug.bind(con),
    debug: con.debug.bind(con),
    info: con.info.bind(con),
    warn: con.warn.bind(con),
    error: con.error.bind(con),
    fatal: con.error.bind(con),
};
function buildBrowserWriters() {
    const levels = Object.keys(browserMethodByLevel).sort((a, b) => DefaultLogLevels[a] - DefaultLogLevels[b]);
    return Object.fromEntries(levels.map((level) => [level, writeLogWithLevel(browserMethodByLevel[level], level.toUpperCase())]));
}
/**
 * Creates the browser logging implementation: pino/browser.js writing formatted
 * lines to the matching console method per level.
 */
export function createBrowserLogger() {
    return pino({
        name: "frontend",
        level: "debug",
        messageKey: "message",
        errorKey: "error",
        formatters: { level: (label) => ({ level: label }) },
        browser: {
            asObject: true,
            write: buildBrowserWriters(),
        },
    });
}
//# sourceMappingURL=browser.js.map